import { alpha, Box, Card, Stack, Typography, useTheme } from '@mui/material';
import HourglassTopRoundedIcon from '@mui/icons-material/HourglassTopRounded';

interface Props {
  variant?: 'banner' | 'compact';
  title?: string;
  body?: string;
}

const DEFAULT_TITLE = "You're on the list";
const DEFAULT_BODY =
  "Homepoint is currently at capacity — we've paused taking on new clients so our " +
  "current buyers and sellers get our full attention. Your account is saved and your " +
  "spot is reserved. We'll email you the moment we reopen. In the meantime, feel free " +
  'to browse listings and explore the market.';

const WaitlistNotice: React.FC<Props> = ({
  variant = 'banner',
  title = DEFAULT_TITLE,
  body = DEFAULT_BODY,
}) => {
  const theme = useTheme();
  const compact = variant === 'compact';

  return (
    <Card
      elevation={0}
      sx={{
        p: compact ? 2.5 : 3,
        borderRadius: 3,
        border: `1px solid ${alpha(theme.palette.primary.main, 0.15)}`,
        background: `linear-gradient(135deg, ${alpha(
          theme.palette.primary.main,
          0.06
        )} 0%, ${alpha(theme.palette.primary.light, 0.12)} 100%)`,
      }}
    >
      <Stack direction={compact ? 'column' : 'row'} spacing={2.5} alignItems="flex-start">
        <Box
          sx={{
            width: 48,
            height: 48,
            flexShrink: 0,
            borderRadius: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: alpha(theme.palette.primary.main, 0.12),
            color: 'primary.main',
          }}
        >
          <HourglassTopRoundedIcon />
        </Box>
        <Box>
          <Typography
            variant="overline"
            sx={{ color: 'primary.main', fontWeight: 700, letterSpacing: 1.2 }}
          >
            At capacity
          </Typography>
          <Typography variant={compact ? 'subtitle1' : 'h6'} fontWeight={700} gutterBottom>
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {body}
          </Typography>
        </Box>
      </Stack>
    </Card>
  );
};

export default WaitlistNotice;
